import React, { useEffect } from 'react';
import { Typography } from '@mui/material';
import { Stack, styled } from '@mui/system';
import { useLocation, useNavigate } from 'react-router';
import { AppTabsPanelContainer } from 'src/components/AppTabsPanelContainer';
import { SINGIN_REDIRECT_URL } from 'src/configs/oidcConfig';

const StyledContainer = styled(Stack)(({ theme }) => ({
    height: '100%',
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.default,
}));

export function NoMatch() {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (location.pathname === SINGIN_REDIRECT_URL) {
            navigate('/', { replace: true });
        }
    }, [location.pathname]);

    return (
        <AppTabsPanelContainer>
            <StyledContainer>
                <Typography variant="h3" mb={2}>
                    Oops!
                </Typography>
                <Typography variant="h4" mb={1}>
                    404 Page not found for <code>{location.pathname}</code>
                </Typography>
                <Typography variant="body1">The page you are looking for doesn't exist.</Typography>
            </StyledContainer>
        </AppTabsPanelContainer>
    );
}
